import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { JiraControllerResponse } from "@ServerTypes/jira/jira.schema";

// The backend support-ticket endpoint used to be a single POST /jira/jiraController multiplexed on
// `value.action`. It is now one discrete route per action. This wrapper preserves every existing call
// site: it reads the `action` off the payload (JSON body, or the multipart `value` field for uploads)
// and posts to the matching discrete route. Only `getList` has a route name that differs from its
// action ("getTicketsList"); every other action maps 1:1 to its path.
const ACTION_TO_PATH: Record<string, string> = {
  getList: "getTicketsList",
};

function resolveJiraPath(data: unknown): string {
  let action: string | undefined;
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    try {
      action = JSON.parse((data.get("value") as string) || "{}")?.action;
    } catch {
      action = undefined;
    }
  } else {
    action = (data as { value?: { action?: string } })?.value?.action;
  }
  return `/jira/${(action && ACTION_TO_PATH[action]) || action}`;
}

export const jiraTicketsUrl = `${getBackendUrl()}/jira/getTicketsList`;

// `data` is either a JSON body or a `FormData` for the upload actions; `resolveJiraPath` handles
// both, and the request body itself is not narrowed by `axiosWrapper.post`.
export async function jiraController(data: unknown) {
  const res = await axiosWrapper.post<JiraControllerResponse>(
    `${process.env.REACT_APP_CUBE_BACKEND}${resolveJiraPath(data)}`,
    data,
  );
  return res;
}
